
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"none","viewBox":"0 0 24 24","width":"38","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.18 11.99a4.55 4.55 0 01-.84-2.67c0-.23.02-.46.05-.69-.45.16-.92.25-1.39.25-.42 0-.84-.08-1.24-.22-.34-.12-.68-.27-1-.44-.14-.1-.3-.17-.46-.23-.87 0-1.3 1.23-1.3 3.68-.03.48.19.94.58 1.23.42.29.91.43 1.42.42h1.4c.68-.84 1.7-1.33 2.78-1.33zm11.15 6.63v-1.08a10.58 10.58 0 00-.43-2.26c-.12-.35-.27-.68-.45-1-.17-.31-.39-.59-.65-.84-.26-.24-.56-.43-.89-.56-.37-.14-.76-.21-1.16-.21-.16.04-.32.12-.45.22l-.76.5c-1.17.74-2.61.92-3.93.5-.39-.12-.76-.28-1.11-.5l-.76-.5c-.13-.1-.29-.18-.45-.22-.4 0-.79.07-1.16.21-.33.13-.63.32-.89.56-.26.25-.48.53-.65.84-.18.32-.33.65-.45 1a10.58 10.58 0 00-.43 2.26v1.08c-.05.75.23 1.47.76 2 .55.49 1.26.75 2 .72h9.1c.74.03 1.45-.23 2-.72.53-.53.81-1.25.76-2zM7.89 3.44A2.59 2.59 0 006 2.66c-.71-.01-1.39.27-1.88.78-.51.49-.79 1.17-.78 1.88-.01.71.27 1.39.78 1.88.49.51 1.17.8 1.88.79.71.01 1.39-.27 1.88-.78.51-.49.79-1.17.78-1.88a2.58 2.58 0 00-.77-1.89zm6.94 3.06A3.866 3.866 0 0012 5.33c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c.02-1.06-.41-2.09-1.17-2.83zM22 11.67c0-2.45-.43-3.68-1.3-3.68-.16.05-.31.13-.45.22-.32.17-.66.32-1 .44-.4.15-.82.23-1.25.23-.47 0-.94-.08-1.38-.24a4.623 4.623 0 01-.8 3.35c1.07.01 2.08.5 2.76 1.33H20c.51.02 1.02-.13 1.44-.42.38-.29.59-.75.56-1.23zm-2.12-8.23a2.665 2.665 0 00-3.76-.01l-.01.01c-.51.49-.79 1.17-.78 1.88-.01.71.27 1.39.78 1.88a2.665 2.665 0 003.76.01l.01-.01c.51-.49.79-1.17.78-1.88.01-.71-.27-1.39-.78-1.88z"}})])
          )
        }
      }
    